import { httpClient } from '@/services/http/httpClient'

import type { IdeaFieldFormat } from '@/types/ideaFieldsFormat'

type IdeaFieldHttpResponse = {
  id: string
  title: string
  description: string
  type: IdeaFieldFormat
  options: { name: string }[]
  obligatoriness: string
  position: number
}

type IdeaFieldsHttpResponse = {
  templates: IdeaFieldHttpResponse[]
}

export type IdeaFieldTemplate = {
  id: string
  title: string
  description: string
  format: IdeaFieldFormat
  options: { name: string }[]
  isMandatory: boolean
  position: number
}

type IdeaFieldTemplatesResponse = {
  ideaFieldTemplates: IdeaFieldTemplate[]
}

export async function getIdeaFieldTemplates(): Promise<IdeaFieldTemplatesResponse> {
  const { data } = await httpClient.get<IdeaFieldsHttpResponse>(
    '/ideas/campaigns/field-templates',
  )

  const ideaFieldTemplates = data.templates.map((ideaField) => ({
    id: ideaField.id,
    title: ideaField.title,
    description: ideaField.description,
    format: ideaField.type,
    options: ideaField.options,
    isMandatory: ideaField.obligatoriness === 'MANDATORY',
    position: ideaField.position,
  }))

  return {
    ideaFieldTemplates,
  }
}
